export default __webpack_public_path__ + "static/media/robot-error.2cc1c837.png";